import React from 'react';
import {translate} from 'react-i18next';
import Button from '@atlaskit/button';
import PropTypes from 'prop-types';
import {trans} from '../../../../../systems/i18n';
import lodash from 'lodash';
import {currentFormatter} from './../../../../common/services/format';
import Input from '../../../../common/components/Input/Super';
import ModalGeneral from './../../../../common/components/ModalGeneral';

class ModalConfirmChangePrice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            unit_price: null,
            reason: "",
            isLoading: false,
            errorDuplicate: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let state = {...prevState};
        state.isLoading = nextProps.isLoading;

        if (lodash.get(nextProps, "item.id", 0) !== prevState.id) {
            state.id = lodash.get(nextProps, "item.id", 0);
            state.unit_price = 0;
            state.reason = "";
            state.isLoading = false;
        }

        return state;
    }

    /**
     * handle action thay đổi value của các input trong form
     * @param event
     */
    onChangeInput(event) {
        let {target} = event;
        if (this.renderError(target.name) !== null) {
            this.props.clearError([target.name]);
        }
        this.setState({
            [target.name]: target.value
        });
        this.props.beginClearErrorUpdatePriceItems({[target.name]: target.value });
    }

    onKeyUpPrice(event) {
        let {target} = event;
        let unit_price_key = parseFloat(target.value);
        this.setState({
            unit_price: unit_price_key
        });
        this.props.beginClearErrorUpdatePriceItems({[target.name]: unit_price_key });
    }

    /**
     * handle action thay đổi value của các unit price
     * @param value
     */
    onChangePrice(value) {
        this.props.clearError(["unit_price"]);
        this.setState({
            "unit_price":  parseFloat(value)
        });
    }

    /**
     * clear error unit price
     */
    onClearPriceError() {
        this.props.clearError(["unit_price"]);
    }

    /**
     * xử lý hành động submit form
     */
    onSubmitForm() {
        let {order, order_item_checked} = this.props;
        let formData = this.state;
        let submitFormData = {
            id: order.id,
            item_ids: order_item_checked,
            unit_price: formData.unit_price,
            reason: formData.reason.trim()
        };
        this.props.onSubmitForm(submitFormData);
    }

    /**
     * Enter submit
     * @param event
     */
    onKeyPress(event) {
        if (event.key === 'Enter') {
            this.onSubmitForm();
        }
    }

    /**
     * Thực hiện render lỗi thông báo ra bên ngoài
     * @param attrName
     * @returns {null}
     */
    renderError(attrName) {
        let {errorUnitPriceItems, t} = this.props;
        let errorItem = lodash.get(errorUnitPriceItems, attrName, {});
        attrName = attrName === "unit_price" ? "unit_price_label" : attrName;
        if (!lodash.isEmpty(errorItem)) {
            switch (Object.keys(errorItem)[0]) {
                case 'required':
                    return t('orderDetail:order_detail.error.' + Object.keys(errorItem)[0], {name: t('orderDetail:order_detail.' + attrName)});
                case 'unique':
                    return t('orderDetail:order_detail.error.' + Object.keys(errorItem)[0], {name: t('orderDetail:order_detail.' + attrName)});
                case 'max.string':
                    let objectmax = lodash.get(errorItem, 'max.string', null);
                    let overLength = lodash.get(objectmax, 'max', null);
                    return t('orderDetail:order_detail.error.max_string', {
                        name: t('orderDetail:order_detail.' + attrName),
                        value: overLength
                    });
                case 'max.numeric':
                    let objectmaxNumber = lodash.get(errorItem, 'max.numeric', null);
                    let overLengthNumber = lodash.get(objectmaxNumber, 'max', null);
                    overLengthNumber = lodash.toInteger(overLengthNumber);
                    overLengthNumber = currentFormatter.toLocaleStringCurrency(overLengthNumber);
                    return t('orderDetail:order_detail.error.max_numeric', {
                        name: t('orderDetail:order_detail.' + attrName),
                        value: overLengthNumber+'¥'
                    });
                case 'integer':
                    let objectmaxNumberPrice = lodash.get(errorItem, 'max.numeric', null);
                    let overLengthNumberPrice = lodash.get(objectmaxNumberPrice, 'max', null);
                    overLengthNumberPrice = lodash.toInteger(overLengthNumberPrice);
                    overLengthNumberPrice = currentFormatter.toLocaleStringCurrency(overLengthNumberPrice);
                    return t('orderDetail:order_detail.error.max_numeric', {
                        name: t('orderDetail:order_detail.' + attrName),
                        value: overLengthNumberPrice
                    });
                case 'min.string':
                    let objectmin = lodash.get(errorItem, 'min.string', null);
                    let length = lodash.get(objectmin, 'min', null);
                    return t('orderDetail:order_detail.error.min_string', {
                        name: t('orderDetail:order_detail.' + attrName),
                        value: length
                    });
                case "status_invalid":
                    return t('orderDetail:order_detail.error.status_invalid');
                default:
                    return null;
            }
        }
        return null;
    }

    existError(attrName){
        let {errorUnitPriceItems} = this.props;
        return lodash.has(errorUnitPriceItems,attrName);
    }

    render() {
        let {onClose, t, order_item_checked, isLoading} = this.props;
        let {reason} = this.state;
        return (
            <ModalGeneral>
                <div className={"a-modal__title"}>
                    <p>
                        {trans("orderDetail:order_detail.edit_unit_price_items", {
                            number: <span
                                className={"a-text--font-blue a-text--bold"}>#{order_item_checked.length}</span>
                        })}
                    </p>
                </div>
                <div className={"row"}>
                    <div className={"col col-sm-12 col-md-6 col-lg-6"}>
                        <div className={'a-group'}>
                            <label className="label label--required a-label ">
                                {t("orderDetail:order_detail.new_unit_price_label")}
                            </label>
                            <br/>
                            <Input
                                unit_price={true}
                                onKeyUp={this.onKeyUpPrice.bind(this)}
                                className={"input input--fullwidth mt-2 input--normal "
                                +(this.existError('unit_price') ? "input--error" : "")}
                                name={"unit_price"}
                                placeholder={t('orderDetail:order_detail.new_unit_price_label')+' ¥'}
                                onChange={this.onClearPriceError.bind(this)}
                                onBlur={this.onChangePrice.bind(this)}
                                onKeyPress={event => this.onKeyPress(event)}
                            />
                            <span className={"a-text--red a-font--10 "+(this.existError('unit_price')?"":"hidden")}>
                                {this.renderError("unit_price")}
                            </span>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-md-12"}>
                        <div className="a-group">
                            <label className="label a-label">
                                {t("orderDetail:order_detail.reason_unit_price")}
                            </label>
                            <textarea
                                style={{width:'95%'}}
                                name={"reason"}
                                onChange={this.onChangeInput.bind(this)}
                                className={"input mt-2 "+(this.existError('reason') ? "input--error" : "")}
                                rows={'4'}
                                value={reason}
                            />
                            <p className="a-text--red a-font--10">{this.renderError("reason")}</p>
                        </div>
                    </div>
                </div>
                <div className="a--group--inline-end mt-2 mb-3 a--user-group-btn">

                    <Button appearance="primary" type="submit"
                            className={"mr-3 a-btn--submit"}
                            onClick={this.onSubmitForm.bind(this)}
                            isLoading={isLoading}
                    >
                        {trans('account_purchaser.btn_action_confirm')}
                    </Button>
                    <a appearance="subtle" onClick={onClose}
                       className={(isLoading ? "hidden " : "") + "a-btn a-btn--none a-btn-link "}>
                        {trans('account_purchaser.btn_action_cancel')}
                    </a>
                </div>
            </ModalGeneral>
        );
    }
}

ModalConfirmChangePrice.defaultProps = {
    item: {
        item_id: 0,
        unit_price_text: '¥ 0',
        unit_price: 0,
        partner_order_item_id: 0
    },
    isLoading: false,
    error: {}
};

ModalConfirmChangePrice.propTypes = {
    item: PropTypes.object,
    onSubmitForm: PropTypes.func,
    onClose: PropTypes.func,
    isLoading: PropTypes.bool,
    error: PropTypes.object
};

export default translate('translations')(ModalConfirmChangePrice);
